export enum BeneficiaryTypeEnum {
  POLICY_HOLDER = 'POLICY_HOLDER',
  WIDOW = 'WIDOW',
  CHILDREN = 'CHILDREN',
  HEIRS = 'HEIRS',
  OTHER = 'OTHER',
  NONE = 'NONE',
}
